<div class="map-container">
    <dtm-map-cesium-map *ngrxLet="isZoneVisible$ as isZoneVisible">
        <dtm-map-azure-maps-layer />
        <dss-shared-lib-active-restrictions-map-layer
            *ngIf="shouldShowActiveRestrictionsLayer$ | ngrxPush"
        ></dss-shared-lib-active-restrictions-map-layer>
        <dtm-map-cylinders-editor [labelsTemplate]="labelsTemplate" [show]="isZoneVisible"></dtm-map-cylinders-editor>
        <dtm-map-prisms-editor
            [labelsTemplate]="labelsTemplate"
            [show]="isZoneVisible"
            (pointLimitReached)="pointLimitReached.emit($event)"
        ></dtm-map-prisms-editor>
    </dtm-map-cesium-map>
</div>

<ng-template #labelsTemplate let-label>
    <div class="default-label" *ngIf="label.show && label.text">
        {{ label.text }}
    </div>
</ng-template>
